import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import type { WithBoundArgs } from '@glint/template';
import HotelBenchmarkInsightGridExpandableGridExpandableItem from 'lumen/components/hotel/benchmark-insight/grid-expandable/grid-expandable-item';

interface HotelBenchmarkInsightGridExpandableGridExpandableSignature {
  Args: {
    expandedIndices: number[];
    toggleExpandedIndex: (index: number) => void;
  };
  Blocks: {
    default: [
      {
        Item: WithBoundArgs<
          typeof HotelBenchmarkInsightGridExpandableGridExpandableItem,
          'expandedIndices' | 'toggleExpandedIndex'
        >;
      },
    ];
  };
}

const HotelBenchmarkInsightGridExpandableGridExpandable = <template>
  <div class="grid w-full grid-cols-2 gap-600">
    {{yield
      (hash
        Item=(component
          HotelBenchmarkInsightGridExpandableGridExpandableItem
          expandedIndices=@expandedIndices
          toggleExpandedIndex=@toggleExpandedIndex
        )
      )
    }}
  </div>
</template> satisfies TOC<HotelBenchmarkInsightGridExpandableGridExpandableSignature>;

export default HotelBenchmarkInsightGridExpandableGridExpandable;
